export class LanguageUtil {
    constructor() { }

    static retornaBrowserLanguage() {
        const language = navigator.language;

        if (language === 'pt' ||
            language === 'pt-BR') {
            return 'pt';
        } else if (language === 'en' ||
            language === 'en-US' ||
            language === 'en-EG' ||
            language === 'en-AU' ||
            language === 'en-GB' ||
            language === 'en-CA' ||
            language === 'en-NZ' ||
            language === 'en-IE' ||
            language === 'en-ZA' ||
            language === 'en-JM' ||
            language === 'en-BZ' ||
            language === 'en-TT') {
            return 'en';
        } else if (language === 'es' ||
            language === 'es-AR' ||
            language === 'es-GT' ||
            language === 'es-CR' ||
            language === 'es-PA' ||
            language === 'es-DO' ||
            language === 'es-MX' ||
            language === 'es-VE' ||
            language === 'es-CO' ||
            language === 'es-PE' ||
            language === 'es-EC' ||
            language === 'es-CL' ||
            language === 'es-UY' ||
            language === 'es-PY' ||
            language === 'es-BO' ||
            language === 'es-SV' ||
            language === 'es-HN' ||
            language === 'es-NI' ||
            language === 'es-PR') {
            return 'es';
        } else {
            return 'en';
        }
    }

    static retornaAcceptLanguage(language) {
        if (language === 'pt') {
            return 'pt-BR';
        } else if (language === 'en') {
            return 'en-US';
        } else if (language === 'es') {
            return 'es-ES';
        } else {
            return 'en-US';
        }
    }

    static retornaLanguage(language) {
        if (language === 'pt') {
            return 'pt_BR';
        } else if (language === 'en') {
            return 'en_US';
        } else if (language === "es") {
            return 'es_ES';
        } else {
            return 'en_US';
        }
    }

}
